import { getRequest,putRequest} from "apiRequest";
import URLS  from '../../constants/ApiConstant';


 const getUser=(data:any)=>{
 return  getRequest(URLS.user,data)
}

 const updateUser=(data:any)=>{
    return  putRequest(URLS.user,data)
}

export default {
    getUser,
    updateUser    
}